import { render, staticRenderFns } from "./snippets-summary-card.vue?vue&type=template&id=1ec2e292&scoped=true&"
import script from "./snippets-summary-card.vue?vue&type=script&lang=js&"
export * from "./snippets-summary-card.vue?vue&type=script&lang=js&"
import style0 from "./snippets-summary-card.vue?vue&type=style&index=0&id=1ec2e292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec2e292",
  null
  
)

export default component.exports